const featuredManagement = () => import('@/pages/featured/index')
const featuredProjectList = () => import('@/pages/featured/projectList/list')
const featuredHouseList = () => import('@/pages/featured/houseList/list')
const featuredAddProject = () => import('@/pages/featured/projectList/operation')
const featuredHouseOperation = () => import('@/pages/featured/houseList/operation')
const featuredTagList = () => import('@/pages/featured/tag/list')
const featuredTagOperation = () => import('@/pages/featured/tag/operation')

export default [
  {
    path: '/',
    component: featuredManagement,
    name: 'featuredManagement',
    children: [
      {
        path: '/project-list',
        component: featuredProjectList,
        meta: [
          {
            name: '精品项目列表',
            url: '/project-list'
          }
        ]
      },
      {
        path: '/project-list/add',
        component: featuredAddProject,
        meta: [
          {
            name: '精品项目列表',
            url: '/project-list'
          },
          {
            name: '新增精选项目',
            url: '/add',
            noCache: true
          }
        ]
      },
      {
        path: '/project-list/edit/:id',
        component: featuredAddProject,
        meta: [{
          name: '精品项目列表',
          url: '/project-list'
        },
        {
          name: '编辑精选项目',
          url: '/edit/:id',
          noCache: true
        }
        ]
      },
      {
        path: '/house-list',
        component: featuredHouseList,
        meta: [
          {
            name: '房源列表',
            url: '/house-list'
          }
        ]
      },
      {
        path: '/house-list/add',
        component: featuredHouseOperation,
        meta: [
          {
            name: '房源列表',
            url: '/house-list'
          },
          {
            name: '新增房源',
            url: '/add'
          }
        ]
      },
      {
        path: '/house-list/edit/:id',
        component: featuredHouseOperation,
        meta: [
          {
            name: '房源列表',
            url: '/house-list'
          },
          {
            name: '编辑房源',
            url: '/edit/:id'
          }
        ]
      },
      {
        path: '/project-tag-list',
        component: featuredTagList,
        meta: [{
          name: '精选项目标签',
          url: '/project-tag-list'
        }]
      },
      {
        path: '/project-tag-list/add',
        component: featuredTagOperation,
        meta: [{
          name: '精选项目标签',
          url: '/project-tag-list'
        }, {
          name: '新增标签',
          url: '/project-tag-list/add'
        }]
      },
      {
        path: '/project-tag-list/set',
        component: featuredTagOperation,
        meta: [{
          name: '精选项目标签',
          url: '/project-tag-list'
        }, {
          name: '新增标签',
          url: '/project-tag-list/set'
        }]
      }
    ]
  }
]
